export const LADE_AUSWAHLWERTE_DOZENT = "ladeAuswahlwerteDozent";
